import React from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { useShowMore } from '../../hooks/useShowMore';
import ButtonMore from '../ButtonMore';

type MyMasonryProps<T> = {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
};

function MyMasonry<T extends object>({ items, renderItem }: MyMasonryProps<T>) {
  // show more hook
  const { visibleItems, showMore, showLess, isAllVisible, hasMore } = useShowMore(items);

  return (
    <div>
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 576: 2, 900: 3 }}>
        <Masonry gutter="24px">
          {visibleItems.map((item, index) => (
            <div className="w-100" key={index}>
              {renderItem(item, index)}
            </div>
          ))}
        </Masonry>
      </ResponsiveMasonry>

      {hasMore && (
        <div className="flex-row justify-center pt-1 w-100">
          {!isAllVisible ? (
            <ButtonMore text="More" onClick={showMore} />
          ) : (
            <ButtonMore text="Show Less" onClick={showLess} />
          )}
        </div>
      )}
    </div>
  );
}

export default MyMasonry;
